import { useEffect, useState } from 'react';

import {
  Redirect,
  Route,
  BrowserRouter as Router,
  Switch,
  useLocation
} from 'react-router-dom';
// eslint-disable-next-line no-unused-vars
import axiosInterceptor from './helpers/axios-helper';
import ScrollToTop from './components/common/ScrollToTop';

////////VIEWS IMPORTS//////
import styled from 'styled-components';

import PageError from './views/PageError/PageError';

import { AnimatePresence } from 'framer-motion';
import { BackofficeRoutes } from './routes/backofficeRoutes';
import {
  BACKOFFICE_LAYOUT,
  DASHBOARD,
  KYC_LAYOUT,
  KYC_START,
  LOGIN,
  MY_HUBS,
  MY_HUBS_GAMING,
  MY_HUBS_PAYMENT,
  MY_HUBS_STAKING,
  MY_HUBS_TRADING,
  ROOT,
  SETTINGS_ACCOUNT,
  SETTINGS_LAYOUT
} from './routes/routes';
import { useWindowWide } from './helpers/wideScreen';

import { useAppSelector } from './app/hooks';
import Spinner from './components/common/Spinner';
import {
  getRefreshToken,
  removeUserFromLS,
  setNewAccessToken,
  setUserToLS
} from './helpers/localstorage-helper';
import { MarqueeNewMembers } from './layout/BackofficeLayout/common/MarqueeNewMembers';
import { TopNav } from './layout/BackofficeLayout/common/TopNav';
import { AuthRoutes } from './routes/authRoutes';
import { KycRoutes } from './routes/kycRoutes';
import { Sidebar } from './layout/BackofficeLayout/common/Sidebar';
import { decodeJwt } from './helpers/helperFunctions';
import { useDispatch } from 'react-redux';
import { changeUserInfo } from './slices/auth-slice';

export const Mobile = styled.div`
  display: none;
  @media (max-width: 800px) {
    display: block;
  }
`;

export const Desktop = styled.div`
  display: block;
  @media (max-width: 800px) {
    display: none;
  }
`;

function App() {
  const dispatch = useDispatch();
  const { userInfo } = useAppSelector((state) => state.auth);

  const [refreshedToken, setRefreshedToken] = useState(false);
  const [goTo, setGoto] = useState('');

  const rToken = getRefreshToken();

  const pathname = window.location.pathname;

  const isBackoffice =
    pathname === BACKOFFICE_LAYOUT
      ? false
      : pathname.includes(BACKOFFICE_LAYOUT);

  async function refreshToken() {
    const response = await window.axios.put(`/authorization/token/refresh`, {
      refreshToken: rToken
    });

    const user = {
      ...userInfo,
      userType: decodeJwt(response.data.data.accessToken)
    };

    dispatch(changeUserInfo(user));

    setUserToLS(user);

    let newAccessToken = response.data.data.accessToken;

    setNewAccessToken(newAccessToken);

    const statusCode = response.status;

    if (statusCode === 200) {
      setRefreshedToken(true);
      setGoto(!isBackoffice ? DASHBOARD : pathname);
    }

    if (statusCode > 400) {
      setRefreshedToken(true);
      setGoto(LOGIN);
      removeUserFromLS();
    }
  }

  useEffect(() => {
    setTimeout(() => {
      if (rToken) {
        refreshToken();
      }
      if (!rToken) {
        setRefreshedToken(true);
        setGoto(LOGIN);
      }
    }, 500);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (!refreshedToken) return <Spinner fullScreen />;

  return (
    <Router>
      {userInfo?.token && (
        <>
          <Sidebar />
          <TopNav />
          <MarqueeNewMembers />
          <ScrollToTop />
        </>
      )}

      <Routes refreshToken={refreshToken} goTo={goTo} />
    </Router>
  );
}

export default App;

const switchKeyNoNested = (key) => {
  switch (key) {
    case MY_HUBS_TRADING:
    case MY_HUBS_PAYMENT:
    case MY_HUBS_GAMING:
    case MY_HUBS_STAKING:
      return MY_HUBS;

    // case SETTINGS_ACCOUNT:
    // case SETTINGS_NOTIFICATIONS:
    // case SETTINGS_PAYMENTS:
    // case SETTINGS_SECURITY:
    // case SETTINGS_TEAM_SETTINGS:
    // case SETTINGS_VIRTUAL_OFFICE:
    //   return SETTINGS_LAYOUT;

    default:
      return key;
  }
};

const Routes = ({ goTo }) => {
  const wide = useWindowWide(800);
  const location = useLocation();

  return (
    <AnimatePresence exitBeforeEnter>
      <Switch location={location} key={switchKeyNoNested(location.pathname)}>
        <Redirect exact from={ROOT} to={goTo} />
        <Redirect exact from={BACKOFFICE_LAYOUT} to={DASHBOARD} />
        <Redirect exact from={KYC_LAYOUT} to={KYC_START} />

        {wide && (
          <Redirect exact from={SETTINGS_LAYOUT} to={SETTINGS_ACCOUNT} />
        )}

        <Route
          path='/backoffice/:path?'
          render={(props) => <BackofficeRoutes {...props} />}></Route>

        <KycRoutes
          path='/kyc/:path?'
          render={(props) => <KycRoutes {...props} />}></KycRoutes>

        <Route
          path='/:path?'
          render={(props) => <AuthRoutes {...props} />}></Route>

        <Route render={(props) => <PageError {...props} />} />
      </Switch>
    </AnimatePresence>
  );
};
